(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-header"]) return;
  try {
    
  /* ---------------------------------------------------------------------
     StickyHeader. Carried over from Dawn's sections/header.liquid, which no
     longer renders on any page, so its own section script never ships and
     <sticky-header> would otherwise be an undefined element. The guard keeps
     this safe if Dawn's header is ever re-added to a template.
     The 'reduce-logo-size' variant is dropped: there is no logo image to
     reduce, the wordmark is type.
     --------------------------------------------------------------------- */
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
        this.setHeaderHeight = this.setHeaderHeight.bind(this);
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        if (!this.header) return;

        this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
        this.headerBounds = {};

        this.setHeaderHeight();
        this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearches = this.querySelectorAll('predictive-search');
        this.drawer = this.querySelector('[data-cc-drawer]');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      setHeaderHeight() {
        if (!this.header) return;
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      disconnectedCallback() {
        if (this.mobileMediaQuery) this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        const observer = new IntersectionObserver((entries, obs) => {
          this.headerBounds = entries[0].intersectionRect;
          obs.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;
        /* Never retract the header out from under an open drawer: the drawer
           panel is anchored to the header, so hiding one hides the other. */
        if (this.drawer && this.drawer.open) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach((disclosure) => disclosure.close());
      }

      closeSearchModal() {
        this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
        this.searchModals.forEach((searchModal) => searchModal.close(false));
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  /* ---------------------------------------------------------------------
     The account dialog anchors to the bottom of its own button. The `open`
     event is composed but does not bubble, so it is caught during capture.
     --------------------------------------------------------------------- */
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  /* ---------------------------------------------------------------------
     Drawer enhancement. The drawer is a native <details> and is fully usable
     without any of this: these three behaviours are additive only.
       1. lock the page behind the open panel
       2. Escape closes and returns focus to the toggle; a click outside closes
       3. crossing into desktop width closes it, so it cannot be left open
          behind a nav that has replaced it
     --------------------------------------------------------------------- */
  (function () {
    const DESKTOP = '(min-width: 990px)';

    function bindDrawer(details) {
      if (!details || details.dataset.ccDrawerBound === 'true') return;
      details.dataset.ccDrawerBound = 'true';

      const panel = details.querySelector('.cc-drawer__panel');

      /* The panel's max-height has to be measured, not assumed: it hangs off the
         bottom of the header, and how far down that is depends on the
         announcement bar, the sticky state and the wrapped wordmark. Publishing
         the measured offset stops the foot of a long menu falling below the fold
         where the scroll lock makes it unreachable. */
      function setPanelBound() {
        if (!panel || !details.open) return;
        const top = Math.max(0, Math.round(panel.getBoundingClientRect().top));
        details.style.setProperty('--cc-drawer-top', `${top}px`);
      }

      details.addEventListener('toggle', () => {
        document.body.classList.toggle('overflow-hidden-tablet', details.open);
        if (details.open) setPanelBound();
      });

      window.addEventListener('resize', setPanelBound);

      if (window.ccA11y && typeof window.ccA11y.bindDetails === 'function') {
        window.ccA11y.bindDetails(details);
      }

      const desktop = window.matchMedia(DESKTOP);
      desktop.addEventListener('change', (event) => {
        if (event.matches && details.open) details.open = false;
      });
    }

    function bindAll(root) {
      (root || document).querySelectorAll('[data-cc-drawer]').forEach(bindDrawer);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindAll());
    } else {
      bindAll();
    }

    /* The theme editor replaces the section's DOM on every setting change. */
    document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
